import React, { useEffect } from 'react';
import { useI18n } from '@/i18n/I18nProvider';

export default function HtmlLangDirProvider() {
  const { locale, dir, t } = useI18n();

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = locale;
      document.documentElement.dir = dir;

      if (t.metaTitle) {
        document.title = t.metaTitle;
      }

      const metaDescriptionEl = document.querySelector('meta[name="description"]');
      if (metaDescriptionEl && t.metaDescription) {
        metaDescriptionEl.setAttribute('content', t.metaDescription);
      }

      const appleTitleEl = document.querySelector('meta[name="apple-mobile-web-app-title"]');
      if (appleTitleEl && t.appleWebAppTitle) {
        appleTitleEl.setAttribute('content', t.appleWebAppTitle);
      }
    }
  }, [locale, dir, t]);

  return null;
}
